import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ImageGenerationService } from '../services/image-generation.service';

@Component({
    selector: 'app-generate-image',
    imports: [FormsModule],
    templateUrl: './generate-image.component.html',
    styleUrls: ['./generate-image.component.scss']
})
export class GenerateImageComponent {
  prompt: string = '';
  generatedImageUrl: string = '';
  isLoading: boolean = false;
  errorMessage: string = '';

  constructor(private imageGenerationService: ImageGenerationService) {}

  async onSubmit() {
    if (!this.prompt.trim()) {
      this.errorMessage = 'Please enter a prompt';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.generatedImageUrl = '';

    try {
      this.generatedImageUrl = await this.imageGenerationService.generateImage(this.prompt);
    } catch (error: any) {
      this.errorMessage = error?.message || 'Failed to generate image. Please try again.';    } finally {
      this.isLoading = false;
    }
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSubmit();
    }
  }

  clearImage() {
    this.generatedImageUrl = '';
    this.prompt = '';
    this.errorMessage = '';
  }
}

